export default "__VITE_ASSET__nsfVXYJt__"